<template>
  <nav>
    <a v-for="tab in tabs" :key="tab.path" :href="tab.path">{{ tab.label }}</a>
  </nav>
</template>

<script>
export default {
  name: 'Navigation',
  props: {
    tabs: {
      type: Array,
      required: false,
      default: () => [
        { label: 'Home', path: '/' },
        { label: 'Mentors', path: '/mentor' },
      ],
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../_variables';

nav {
  display: flex;
  justify-content: center;
  margin-top: -50px;
  margin-bottom: 100px;

  a {
    font-family: 'Avenir', sans-serif;
    font-weight: 700;
    font-size: var(--small-text);

    color: black;
    text-decoration: none;
    text-transform: uppercase;
    margin-left: 1em;
    margin-right: 1em;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
